import { WireAnalyticsEvent } from 'scenes/common/types';
import { RetrieveFunnelState } from 'scenes/retrieve/types';

import { toWirePage } from './page';
import { toWireFormData } from './formData';
import { WireRetrieveAnalytics } from '../types';

export const marshalViewLoadedEvent = (
  state: RetrieveFunnelState,
  cid: string,
  qid: string
): WireRetrieveAnalytics => ({
  event: WireAnalyticsEvent.ViewLoaded,
  page: toWirePage(state, cid, qid),
  formData: toWireFormData(state),
});

export const marshalRetrieveQuoteStartEvent = (
  state: RetrieveFunnelState,
  quoteNumber: string
): WireRetrieveAnalytics => ({
  event: WireAnalyticsEvent.RetrieveQuoteStart,
  page: toWirePage(state),
  formData: toWireFormData(state, quoteNumber),
});

export const marshalRetrieveQuoteCompleteEvent = (
  state: RetrieveFunnelState
): WireRetrieveAnalytics => ({
  event: WireAnalyticsEvent.RetrieveQuoteComplete,
  page: toWirePage(state),
  formData: toWireFormData(state),
});

export const marshalCallUsEvent = (
  state: RetrieveFunnelState
): WireRetrieveAnalytics => ({
  event: WireAnalyticsEvent.CallUs,
  page: toWirePage(state),
  formData: toWireFormData(state),
});
